import {createAsyncThunk} from '@reduxjs/toolkit';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';
import {importItemsMessages} from '../../utils/constants/messages';
import {itemImportApi} from 'api';
import {TGetItemBankImportApiResponse} from 'models/library/items-import';

export const importItemsThunk: any = createAsyncThunk<TGetItemBankImportApiResponse, any>(
  `${prefix} importItems`,
  async (itemImportId: number, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await itemImportApi.startItemBankImport(itemImportId);
      dispatch(toastNotificationManager.createSuccessToastAction(importItemsMessages.importStarting));
      return parsedBody;
    } catch (error) {
      dispatch(toastNotificationManager.createErrorToastAction(error.parsedBody));
      return rejectWithValue({error});
    }
  }
);
